import { FC } from 'react';
import { SvgProps } from '../interfaces/Icon';

const Close: FC<SvgProps> = ({ size, className, color }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0909 10.1818C10.5888 10.1818 10.1818 10.5888 10.1818 11.0909V19.2727C10.1818 19.7748 10.5888 20.1818 11.0909 20.1818H19.2727C19.7748 20.1818 20.1818 19.7748 20.1818 19.2727V11.0909C20.1818 10.5888 19.7748 10.1818 19.2727 10.1818H11.0909ZM8.36364 11.0909C8.36364 9.58468 9.58468 8.36364 11.0909 8.36364H19.2727C20.779 8.36364 22 9.58468 22 11.0909V19.2727C22 20.779 20.779 22 19.2727 22H11.0909C9.58468 22 8.36364 20.779 8.36364 19.2727V11.0909Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.72727 3.81818C4.48617 3.81818 4.25494 3.91396 4.08445 4.08445C3.91396 4.25494 3.81818 4.48617 3.81818 4.72727V12.9091C3.81818 13.1502 3.91396 13.3814 4.08445 13.5519C4.25494 13.7224 4.48617 13.8182 4.72727 13.8182H5.63636C6.13844 13.8182 6.54545 14.2252 6.54545 14.7273C6.54545 15.2294 6.13844 15.6364 5.63636 15.6364H4.72727C4.00395 15.6364 3.31026 15.349 2.7988 14.8376C2.28734 14.3261 2 13.6324 2 12.9091V4.72727C2 4.00396 2.28734 3.31026 2.7988 2.7988C3.31026 2.28734 4.00396 2 4.72727 2H12.9091C13.6324 2 14.3261 2.28734 14.8376 2.7988C15.349 3.31026 15.6364 4.00395 15.6364 4.72727V5.63636C15.6364 6.13844 15.2294 6.54545 14.7273 6.54545C14.2252 6.54545 13.8182 6.13844 13.8182 5.63636V4.72727C13.8182 4.48617 13.7224 4.25494 13.5519 4.08445C13.3814 3.91396 13.1502 3.81818 12.9091 3.81818H4.72727Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Close;
